module.exports = __webpack_public_path__ + "static/media/cancel_black_24dp.a1418072.svg";